import { memo } from 'react';
import { ProfileEditMailAddressTemplate } from 'components/templates/ProfileEditMailAddressTemplate';

type Props = {};

export const ProfileEditMailAddressPage = memo((_props: Props) => {
	return <ProfileEditMailAddressTemplate />;
});
